<template>
    <div  class="slider-price-in">
        <br>
        <div class="slider" ref="slider-hide"
             :data-miprice="result.VALUES.MIN.VALUE && result.VALUES.MAX ? result.VALUES.MIN.VALUE : 0"
             :data-maprice="result.VALUES.MIN.VALUE && result.VALUES.MAX ? result.VALUES.MAX.VALUE : 5000"
             :data-priceof="result.VALUES.MIN.HTML_VALUE"
             :data-priceto="result.VALUES.MAX.HTML_VALUE">

              <input class="min-price" type="hidden"
                     :name="result.VALUES.MIN.CONTROL_NAME"
                     :id="result.VALUES.MIN.CONTROL_ID"
                     :value="result.VALUES.MIN.HTML_VALUE">
              <input class="max-price" type="hidden"
                     :name="result.VALUES.MAX.CONTROL_NAME"
                     :id="result.VALUES.MAX.CONTROL_ID"
                     :value="result.VALUES.MAX.HTML_VALUE">
        </div>
        <div class="slider-price-minMax">
            <span class="min" ref="min-valueTitle"></span>
            <span class="max" ref="max-valueTitle"></span>
        </div>

        <div v-if="showPlashka" class="filter-plashka filter-plashka--slider">
          <span class="filter-plashka__count">Знайдено: {{ foundCount }}</span>
          <a :href="applyLink" class="filter-plashka__apply">Показати</a>
        </div>
    </div>

</template>

<script>
    export default {
        name: "catalog-filter-price_slider",
        props: ["result", "mess", "foundCount", "applyLink", "showPlashka"],
        data() {
            return {
                priceSlider:{},

            };
        },
        watch:{
            result() {
                let min = this.result.VALUES.MIN.HTML_VALUE?this.result.VALUES.MIN.HTML_VALUE:this.result.VALUES.MIN.VALUE;
                let max = this.result.VALUES.MAX.HTML_VALUE?this.result.VALUES.MAX.HTML_VALUE:this.result.VALUES.MAX.VALUE;
                this.priceSlider.hidingTooltipSlider.noUiSlider.set([min, max]);
            }
        },
        mounted() {
            if(this.result.VALUES.MIN.VALUE!==this.result.VALUES.MAX.VALUE) {
                this.priceSlider.minPrice = this.result.VALUES.MIN.VALUE ? this.result.VALUES.MIN.VALUE : 0;
                this.priceSlider.maxPrice = this.result.VALUES.MAX.VALUE ? this.result.VALUES.MAX.VALUE : 5000;
                if (this.priceSlider.minPrice === this.priceSlider.maxPrice) {
                    this.priceSlider.minPrice = this.priceSlider.minPrice - 0.01;
                    this.priceSlider.maxPrice = this.priceSlider.maxPrice + 0.01;
                }
                this.priceSlider.startMinPrice = this.priceSlider.minPrice;
                this.priceSlider.startMaxPrice = this.priceSlider.maxPrice;
                if (this.result.VALUES.MIN.HTML_VALUE) {
                    this.priceSlider.startMinPrice = this.result.VALUES.MIN.HTML_VALUE;
                }
                if (this.result.VALUES.MAX.HTML_VALUE) {
                    this.priceSlider.startMaxPrice = this.result.VALUES.MAX.HTML_VALUE;
                }
                this.priceSlider.hidingTooltipSlider = this.$refs['slider-hide'];
                window.noUiSlider.create(this.priceSlider.hidingTooltipSlider, {
                    connect: true,
                    range: {
                        min: +Math.round(this.priceSlider.minPrice),
                        max: +Math.round(this.priceSlider.maxPrice)
                    },
                    start: [+Math.round(this.priceSlider.startMinPrice), +Math.round(this.priceSlider.startMaxPrice)],
                    ariaFormat: wNumb({
                        decimals: 0
                    }),
                    format: wNumb({
                        decimals: 0,
                        suffix: '₴'
                    }),
                    tooltips: false
                });
                const min = this.$refs['min-valueTitle'];
                const max = this.$refs['max-valueTitle'];
                this.priceSlider.hidingTooltipSlider.noUiSlider.on('update', values => {
                    min.innerHTML = values[0];
                    max.innerHTML = values[1];
                    values[0] = parseInt(values[0]);
                    values[1] = parseInt(values[1]);
                    if (values[0] === Math.round(this.priceSlider.minPrice)) {
                        values[0] = "";
                    }
                    if (values[1] === Math.round(this.priceSlider.maxPrice)) {
                        values[1] = "";
                    }
                    $(this.priceSlider.hidingTooltipSlider).find('.min-price').val(values[0]);
                    $(this.priceSlider.hidingTooltipSlider).find('.max-price').val(values[1]);
                });
                this.priceSlider.hidingTooltipSlider.noUiSlider.on('end', (values) => {
                    this.$emit('setFilter', { isPriceSlider: true });
                });
            }
        }
    }
</script>

<style scoped>
.slider-price-in {
  position: relative;
}

.filter-plashka--slider {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;
  z-index: 10;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #aaa;
  padding: 5px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  font-size: 12px;
}
</style>